module.exports = __webpack_public_path__ + "img/project_background_img@2x.png.612d396.webp";